// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3ogb_","errorLogs":"EditorFooter_errorLogs__1aoL0"};